// src/Lexpromt/hooks/usePrompts.js
import { useState, useEffect } from "react";
import * as promptService from "../services/promptService";

export default function usePrompts(departmentFilter = "All") {
  const [prompts, setPrompts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const unsubscribe = promptService.subscribeToPrompts(
      (list) => {
        setPrompts(list);
        setLoading(false);
      },
      departmentFilter
    );
    return () => unsubscribe();
  }, [departmentFilter]);

  return { prompts, loading };
}
